{
  "title": "Packing Label Print",
  "subtitle": "Print one shipment label per package for a completed packing task.",
  "tabs": {
    "print": "Print",
    "reprint": "Reprint"
  },
  "completedOnly": "Only completed packing tasks appear here — labels can't print until packing is completed and its packages are saved.",
  "selectionCriteria": "Selection Criteria",
  "selectTask": "Packing Task",
  "selectTemplate": "Label Template",
  "noTemplatesAvailable": "No templates available for this task — design one in Label Designer.",
  "taskDetails": "Task Details",
  "taskFields": {
    "source": "Dispatch Order / Pick List",
    "packageCount": "Packages"
  },
  "configuration": "Print Configuration",
  "onePerPackageHint": "One label prints per package — this task has {{count}} package(s).",
  "sendingToPrinter": "Preparing...",
  "printLabels": "Print {{count}} Label(s)",
  "canvasPreviewTitle": "Label Preview",
  "selectTemplatePrompt": "Select a packing task and template to preview the label.",
  "noLabelsToPreview": "This packing task has no packages to preview.",
  "history": {
    "title": "Recent Print History",
    "date": "Date",
    "task": "Packing Task #",
    "source": "Source",
    "template": "Template",
    "quantity": "Qty",
    "printer": "Printer/Station",
    "user": "Printed By"
  },
  "reprint": {
    "selectionCriteria": "Select Packing Task",
    "noPrintedTasks": "No packing tasks have any printed labels yet.",
    "noHistory": "No labels have been printed yet for this task.",
    "labelCount": "Labels",
    "reprintButton": "Reprint"
  }
}
